import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  }
};

const enhance = compose();

const UserTableHead = enhance(({ order, orderBy, onRequestSort }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell />
        <TableCell sortDirection={orderBy === 'groupName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'groupName'}
            direction={order}
            onClick={() => {
              onRequestSort('groupName');
            }}
          >
            運営会社名
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'streetAddress' ? order : false}>
          <TableSortLabel
            active={orderBy === 'streetAddress'}
            direction={order}
            onClick={() => {
              onRequestSort('streetAddress');
            }}
          >
            住所
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'phone' ? order : false}>
          <TableSortLabel
            active={orderBy === 'phone'}
            direction={order}
            onClick={() => {
              onRequestSort('phone');
            }}
          >
            電話番号
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'email' ? order : false}>
          <TableSortLabel
            active={orderBy === 'email'}
            direction={order}
            onClick={() => {
              onRequestSort('email');
            }}
          >
            メールアドレス
          </TableSortLabel>
        </TableCell>
        <TableCell />
        <TableCell />
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(UserTableHead);
